import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from 'react';

import FinanceCustomerPopup from '@components/common/biz/FinanceCustomerPopup';
import SatInput from '@components/common/satUI/SatInput';
import SatButton from '@components/common/satUI/SatButton';
import SatModal from '@components/common/satUI/SatModal';
import { SPECIAL_FINANCE_CUST_TYPE_CODE } from '@common/constants';

const FinanceCustomer = forwardRef((props, ref) => {
  const {
    customerInfo: { custNo, corporation = {} },
    updateCustomerInfo,
  } = props;

  const [specialFinance, setSpecialFinance] = useState('등록 이력이 없습니다.');
  const [generalFinance, setGeneralFinance] = useState('');
  const [financeCustomerPopupVisible, setFinanceCustomerPopupVisible] =
    useState(false);

  useImperativeHandle(ref, () => ({
    showFinanceCustomerPopup() {
      setFinanceCustomerPopupVisible(true);
    },
  }));

  useEffect(() => {
    const { specialFinanceCustTypeCode, generalFinanceCustomerYN } =
      corporation;
    if (specialFinanceCustTypeCode) {
      const specialFinanceName = SPECIAL_FINANCE_CUST_TYPE_CODE.find(
        item => item.code === specialFinanceCustTypeCode,
      )?.name;
      setSpecialFinance(
        specialFinanceCustTypeCode === '2'
          ? `일반금융소비자(${specialFinanceName})`
          : `전문금융소비자(${specialFinanceName})`,
      );

      if (specialFinanceCustTypeCode === '1') {
        setGeneralFinance(
          generalFinanceCustomerYN === 'Y'
            ? '동의(일반금융소비자)'
            : '미동의(전문금융소비자)',
        );
      }
    } else {
      setSpecialFinance('등록 이력이 없습니다.');
      setGeneralFinance('');
    }
  }, [corporation]);

  return (
    <>
      <h2 className="tit-con">일반 / 전문금융 소비자 여부</h2>
      <div className="box two">
        <SatInput
          label={'전문금융소비자 여부'}
          value={specialFinance}
          readOnly
          suffix={() => {
            if (corporation?.specialFinanceCustTypeCode !== '1') {
              return (
                <SatButton
                  styleClass={'btn-s blue w-60'}
                  label={
                    corporation?.specialFinanceCustTypeCode ? '수정' : '등록'
                  }
                  onClick={() => setFinanceCustomerPopupVisible(true)}
                />
              );
            }
          }}
        />
        {corporation?.specialFinanceCustTypeCode === '1' && (
          <SatInput
            label={'일반금융소비자 대우 여부'}
            value={generalFinance}
            readOnly
            suffix={() => (
              <SatButton
                styleClass={'btn-s blue w-60'}
                label={'수정'}
                onClick={() => setFinanceCustomerPopupVisible(true)}
              />
            )}
          />
        )}
      </div>

      <SatModal
        visible={financeCustomerPopupVisible}
        setVisible={() => setFinanceCustomerPopupVisible(false)}
        type={'fullPop'}
        onCloseButton
      >
        <FinanceCustomerPopup
          custNo={custNo}
          corporation={corporation}
          onOk={data => {
            updateCustomerInfo(data);
            setFinanceCustomerPopupVisible(false);
          }}
          onClose={() => setFinanceCustomerPopupVisible(false)}
        />
      </SatModal>
    </>
  );
});

export default FinanceCustomer;
